import { fetchRequest } from "@/plugins/fetchRequest";

const actions = {
  getCNPJ({ commit }: StoreProp, { cnpj }: UnknownObj) {
    return new Promise((resolve, reject) => {
      fetchRequest({ url: `/cnpj/${cnpj}` })
        .then((responseData = {}) => {
          const { companyName, fantasyName } =
            responseData?.data || responseData;
          if (commit) {
            resolve({ companyName, fantasyName });
          }
        })
        .catch((err: UnknownObj) => {
          reject(err);
        });
    });
  }
};

export default actions;
